function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M21.6534 4.8667H10.3467C7.05339 4.8667 4.38672 7.5467 4.38672 10.8267V23.3734C4.38672 26.6534 7.06672 29.3334 10.3467 29.3334H21.6401C24.9334 29.3334 27.6 26.6534 27.6 23.3734V10.8267C27.6134 7.53337 24.9334 4.8667 21.6534 4.8667Z",
  fill: "#76C440"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1333 2.6665H12.8667C11.48 2.6665 10.3467 3.7865 10.3467 5.17317V6.4265C10.3467 7.81317 11.4667 8.93317 12.8533 8.93317H19.1333C20.52 8.93317 21.64 7.81317 21.64 6.4265V5.17317C21.6533 3.7865 20.52 2.6665 19.1333 2.6665Z",
  fill: "#76C440"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0001 17.2666H10.6667C10.1201 17.2666 9.66675 16.8133 9.66675 16.2666C9.66675 15.7199 10.1201 15.2666 10.6667 15.2666H20.0001C20.5467 15.2666 21.0001 15.7199 21.0001 16.2666C21.0001 16.8133 20.5467 17.2666 20.0001 17.2666Z",
  fill: "#76C440"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5067 22.6001H10.6667C10.1201 22.6001 9.66675 22.1468 9.66675 21.6001C9.66675 21.0534 10.1201 20.6001 10.6667 20.6001H16.5067C17.0534 20.6001 17.5067 21.0534 17.5067 21.6001C17.5067 22.1468 17.0534 22.6001 16.5067 22.6001Z",
  fill: "#76C440"
});

function SvgTotalMonitors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalMonitors);
export default __webpack_public_path__ + "static/media/total-monitors.3a215238.svg";
export { ForwardRef as ReactComponent };